<template>
    <div class="navigation">
        <div class="trigger" @click="switchExpands">
            <svg viewBox="0 0 93 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="93" height="18"/>
                <rect y="27" width="93" height="18"/>
                <rect y="54" width="93" height="18"/>
            </svg>
        </div>
        <div class="expand" v-bind:class="[page.ui.show_menu ? 'show' : 'hide']">
            <a class="logo" v-bind="{href:config.relative_path}" title="На главную">
                <img v-if="!userStore.user.demo_mode" v-bind="{src:config.relative_path+'/images/Logo_vershina.png'}" alt="Вершина">
                <img v-else v-bind="{src:config.relative_path+'/images/Logo_demo.png'}" alt="Демо">
            </a>
            <ul class="lv_1">
                <li>
                    <router-link to="/main">Личный кабинет</router-link>
                </li>
                <li>
                    <router-link to="/orders">Заказы</router-link>
                </li>
                <li>
                    <router-link to="/search">Поиск товаров</router-link>
                </li>
                <li>
                    <router-link to="/promo">Акции</router-link>
                </li>
                <li v-if="this.userStore.user.oth.length>0" v-bind:class="[expand === 'ОТХ' ? 'expand' : '']" @click="set_expand('ОТХ')">
                    <a href="#" class="owner">ОТХ</a>
                    <ul class="lv_2">
                        <li>
                            <router-link to="/basket_oth">Реализация</router-link>
                        </li>
                        <!--            <li><a href="#">Проверка маркировки</a></li>-->
                        <li><a href="/b2b/oth_help" target="_blank">Инструкции</a></li>
                    </ul>
                </li>

                <!--        <li><router-link to="/garantie">Расширенная гарантия</router-link></li>-->

                <li v-bind:class="[expand === 'Полезное' ? 'expand' : '']" @click="set_expand('Полезное')"><a href="#" class="owner">Полезное</a>
                    <ul class="lv_2">
                        <li><a href="/b2b/tyres_calc">Шинный калькулятор</a></li>
                        <li><a href="/b2b/status_marking">Проверка маркировки</a></li>
                    </ul>
                </li>


                <li v-bind:class="[expand === 'Вершина' ? 'expand' : '']" @click="set_expand('Вершина')"><a href="#" class="owner">Вершина</a>
                    <ul class="lv_2">
                        <li v-for="item in dicStore.vershina_links.results" :key="item.id"><a v-bind:href="item.properties.url_1.value" target="_blank">{{ item.properties.zagolovok.value }}</a></li>
                    </ul>
                </li>
                <!--                <li><a href="/b2b">Старая B2B</a></li>-->
            </ul>
        </div>
        <div class="widgets" v-bind:class="[page.ui.fixed_menu === true ? 'w_is_fixed' : 'w_is_static']">

            <div class="widget" @click="route_to('Main')">
                <div class="ico ico_user"></div>
                <div class="txt">
                    <div class="title">{{ userStore.user.login }}</div>
                    <div class="link">в личный кабинет</div>
                </div>
            </div>

            <div class="widget" @click="route_to('Basket')">
                <div class="ico ico_basket"></div>
                <div class="txt" v-if="userStore.user.web_basket.count===0">
                    <div class="title">Корзина пуста</div>
                </div>
                <div class="txt" v-else>
                    <div class="title">В корзине: {{ userStore.user.web_basket.count }}</div>
                    <div class="info">На сумму: {{ userStore.user.web_basket.summa }}</div>
                    <div class="link">открыть корзину</div>
                </div>
            </div>

            <div v-if="this.userStore.user.oth.length>0" class="widget" @click="route_to('BasketOth')">
                <div class="ico ico_basket"></div>
                <div class="txt" v-if="userStore.user.web_basket_oth.count===0">
                    <div class="title">Реализация<br> нет</div>
                </div>
                <div class="txt" v-else>
                    <div class="title">Реализация: {{ userStore.user.web_basket_oth.count }}</div>
                    <div class="link">открыть реализацию</div>
                </div>
            </div>


            <div class="widget">
                <div class="ico"><input type="checkbox" value="1" v-model="userStore.user.demo_mode" :true-value="1" :false-value="0" @change="changedemo()"></div>
                <div class="txt">
                    <div class="title">Режим<br> демонстрации</div>
                </div>
            </div>


        </div>
        <div class="contacts" v-bind:class="[page.ui.show_menu ? 'show' : 'hide']">
            <a v-bind:href="dicStore.ui_el.results[13].properties.link.value" class="phone">{{ dicStore.ui_el.results[13].properties.txt.value }}</a>
            <div class="adress" v-html="dicStore.ui_el.results[13].properties.editor.value"></div>
        </div>
    </div>
</template>

<script>
import {useUserStore} from '@/stores/UserStore'
import {useDicStore} from '@/stores/DicStore'
import {useProductsStore} from "@/stores/ProductsStore";

export default {
    name: 'navigation',
    props: ['page', 'config'],
    setup() {
        const userStore = useUserStore();
        const dicStore = useDicStore();

        return {userStore, dicStore};
    },
    data: function () {
        return {
            expand: '',
        }
    },
    methods: {
        changedemo() {

            const ProductsStore = useProductsStore();
            ProductsStore.products.config.on_load = true;

            this.userStore.change_u_settings().then(this.response_process);
        },
        route_to(name) {

            try {
                this.$router.push({name: name})
            } catch (error) {
                if (!(error instanceof NavigationDuplicated)) {
                    //throw error;
                }
            }
        },
        set_expand(reffer) {
            if (this.expand !== reffer) {
                this.expand = reffer;
            } else {
                this.expand = '';
            }
        },
        switchExpands() {
            if (this.page.ui.show_menu == true) {
                this.hideExpands();
            } else {
                this.showExpands();
            }
        },
        showExpands() {
            this.page.ui.show_menu = true;
        },
        hideExpands() {
            this.page.ui.show_menu = false;
        },
    },
}
</script>

<style scoped>
.trigger {
    display: none;
}

.widgets {
    padding: 5px 0 5px 22px;
}

.w_is_fixed {
    position: fixed;
    top: 0px;
    left: 0px;
    background-color: #174A8B;
    padding: 5px 20px 20px 22px;
}

.w_is_static {
    position: static;
}

.widget {
    display: flex;
    flex-direction: row;
    cursor: pointer;
    color: #FFF;
    padding: 14px 0 14px 0;
}

.widget .ico {
    width: 39px;
    height: 39px;
    text-align: center;
    line-height: 36px;
    font-size: 30px;
    margin: 0 5px 0 0;
    background-size: 31px 31px;
    background-position: center;
    background-repeat: no-repeat;
}

.widget .ico_user {
    background-image: url('/panel/images/user.svg');
}

.widget .ico_basket {
    background-image: url('/panel/images/basket.svg');
}

.widget .txt {
    flex-direction: column;
}

.widget .title {
    font-size: 15px;
    font-weight: bold;
    text-transform: uppercase;
}

.widget .link {
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    text-decoration: underline;
}

.logo {
    display: flex;
    width: 94px;
    height: 94px;
    margin: 35px auto 35px auto;
    justify-content: center;
}

.logo img {
    /*width: 100%;*/
    /*height: auto;*/
    margin: auto;
}

.lv_1 {
    padding: 0 20px 0 20px;
}

.lv_1 li {

}

.lv_1 li a {
    display: block;
    font-size: 16px;
    font-weight: 900;
    color: #FFF;
    text-decoration: none;
    border-bottom: solid 1px #1B3D5A;
    padding: 13px 6px 14px 14px;
}

.lv_1 li a:hover {
    color: #1B3D5A;
    background-color: #009ED5;
}

.lv_1 li a.router-link-active {
    color: #1B3D5A;
    background-color: #FFF;
}

.lv_1 li.expand a.owner {
    color: #FFF;
    background-color: #40769E;
}

.lv_1 li a.owner::after {
    content: '';
    background-image: none;
    display: none;
}

.lv_1 li.expand a.owner::after {
    content: '';
    background-image: url('/panel/images/trangle_down.svg');
    background-size: 12px 12px;
    background-repeat: no-repeat;
    background-position: 0 6px;
    height: 17px;
    width: 12px;
    display: inline-flex;
    margin: 0 0 0 8px;
}

.lv_2 {
    background-color: #1B3D5A;
    padding: 8px 0px 12px 0px;
    display: none;
}

.lv_1 li.expand .lv_2 {
    display: block;
}

.lv_2 li a {
    font-size: 14px;
    color: #FFF;
    text-decoration: underline;
    font-weight: normal;
    line-height: 20px;
    padding: 6px 18px 6px 18px;
}

.lv_2 li a:hover {
    text-decoration: none;
}

.contacts {
    padding: 35px 0 0 26px;
}

.phone {
    color: #FFF;
    text-decoration: none;
    font-weight: 500;
    font-size: 20px;
}

.adress {
    padding: 28px 0 28px 0;
    color: #7593BA;
    font-size: 16px;
    line-height: 19px;
    font-weight: 400;
}

.widget .ico input {
    width: 50%;
    height: 50%;
    padding: 0;
    margin: auto;
    display: block;
}

.navigation {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
}

@media only screen and (max-width: 1200px) {
    .navigation {
        position: relative;
        padding-top: 75px;
    }

    .navigation .show {
        display: block;
    }

    .navigation .hide {
        display: none;
    }

    .trigger {
        display: block;
        position: absolute;
        top: 16px;
        left: 10px;
        width: 30px;
        height: 30px;
        z-index: 850;
        cursor: pointer;
    }

    .trigger svg {
        width: 30px;
        height: 30px;
        margin: 0px 0 0 0px;
        fill: #FFF;
    }

    .trigger:hover svg {
        fill: #009ED5;
    }

    .widgets {
        display: flex;
        position: absolute;
        top: 0px;
        right: 0px;
        flex-direction: row-reverse;
        padding: 0 0 0 0;
        margin-left: 50px;
    }

    .widget {
        padding: 0 0 0 0;
        flex-direction: column;
        display: flex;
        cursor: pointer;
        flex-wrap: wrap;
        align-content: center;
        justify-content: flex-start;
        align-items: center;
    }

    .widget .ico {
        width: 20px;
        height: 20px;
        margin: 5px;
    }

    .widget .ico_user {
        background-size: 20px 20px;
    }

    .widget .ico_basket {
        background-size: 20px 20px;
    }

    .widget .ico input {
        width: 100%;
        height: 100%;
        padding: 0;
        margin: 0;
        display: block;
    }

    .widget .txt {
        margin-top: 10px;
        padding: 0 10px;
        text-align: center;;
    }

    .widget .txt .title {
        font-size: 10px;
    }
}

</style>
